export enum DeployValidationMessage {
    NoUnlockTrackersSpecified= "No unlock trackers specified",
    InsecureResourcesDetected = "Some resources are not secure",
    IncorrectMicrositeHosting = "Some microsites are not hosted on the Rezonence CDNs",
    InvalidUrlDetected = "Invalid URL detected"
}
